import { render, staticRenderFns } from "./BlogDetailView.vue?vue&type=template&id=6c77ea67&scoped=true"
import script from "./BlogDetailView.vue?vue&type=script&lang=js"
export * from "./BlogDetailView.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailView.vue?vue&type=style&index=0&id=6c77ea67&prod&lang=scss&scoped=true"
import style1 from "./BlogDetailView.vue?vue&type=style&index=1&id=6c77ea67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c77ea67",
  null
  
)

export default component.exports